export default [
  {
    path: 'afiliados',
    name: 'afiliados',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Afiliados',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados' }
      ]
    }
  },
]